import { render, staticRenderFns } from "./InvoicesCredits.vue?vue&type=template&id=38a55658&"
import script from "./InvoicesCredits.vue?vue&type=script&lang=js&"
export * from "./InvoicesCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports